/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tabs-container[_ngcontent-%COMP%]{position:relative;text-align:center;z-index:2}.tabs-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{width:50%;height:55px;background-color:#6bbe49;color:#fff;text-transform:uppercase;opacity:1}@media screen and (max-width:350px){.tabs-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{width:100%}}@media only screen and (min-width:960px){.tabs-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{width:16.5%}}.tabs-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-label-active[_ngcontent-%COMP%]{background-color:#fff;color:#6bbe49}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/downtown-life/downtown-life.component.scss.shim.ngstyle.js.pre-build-optimizer.js